var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftIcon = function SvgGiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "96.4813479%",
    y2: "96.4813479%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9191FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F075C7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "/redeem",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Redeem---Desktop-@-1440---Create-Account",
    transform: "translate(-332.000000, -190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-/-Redeem",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gift-Icon",
    transform: "translate(332.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Gift-/-Filled",
    transform: "translate(14.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.751125,9.05981486 C23.0385,8.57756486 24.88425,7.31568986 24.693375,5.81568986 C24.60225,5.09643986 24.03,4.40831486 23.27025,4.10343986 C22.993875,3.99243986 22.7085,3.93768986 22.41975,3.93768986 C21.813375,3.93768986 21.192,4.17918986 20.609625,4.65131486 C19.24725,5.75531486 18.831375,8.09118986 18.74925,9.66431486 C18.7545,9.77568986 18.75825,9.88256486 18.7605,9.98193986 C19.363125,9.85256486 20.33475,9.59043986 21.751125,9.05981486 L21.751125,9.05981486 Z M17.2485,9.71681486 C17.18325,8.28993986 16.850625,5.83481486 15.390375,4.65131486 C14.808,4.17918986 14.186625,3.93768986 13.58025,3.93768986 C13.2915,3.93768986 13.006125,3.99243986 12.730125,4.10343986 C11.97,4.40831486 11.398125,5.09643986 11.30625,5.81568986 C11.11575,7.31568986 12.961875,8.57756486 14.24925,9.05981486 C15.66525,9.59043986 16.63725,9.85256486 17.239875,9.98193986 C17.24175,9.89831486 17.244375,9.80943986 17.2485,9.71681486 L17.2485,9.71681486 Z M30.784125,11.4984399 L30.784125,15.3309399 C30.784125,16.0974399 30.10575,16.7214399 29.2725,16.7214399 L28.86675,16.7214399 L28.227375,16.7214399 L7.773,16.7214399 L7.133625,16.7214399 L6.7275,16.7214399 C5.89425,16.7214399 5.215875,16.0974399 5.215875,15.3309399 L5.215875,11.4984399 C5.215875,10.7315649 5.89425,10.1075649 6.7275,10.1075649 L12.90975,10.1075649 C11.092125,9.19068986 9.5715,7.56768986 9.818625,5.62631486 C9.979125,4.36443986 10.90275,3.22031486 12.17175,2.71106486 C13.5345,2.16393986 15.0525,2.44668986 16.335,3.48618986 C17.108625,4.11318986 17.63775,4.96556486 18,5.86968986 C18.361875,4.96556486 18.891375,4.11318986 19.665,3.48618986 C20.947875,2.44593986 22.465125,2.16393986 23.828625,2.71106486 C25.097625,3.22031486 26.02125,4.36481486 26.181375,5.62631486 C26.4285,7.56768986 24.90825,9.19068986 23.09025,10.1075649 L29.2725,10.1075649 C30.10575,10.1075649 30.784125,10.7315649 30.784125,11.4984399 L30.784125,11.4984399 Z M28.977375,18.2214399 L28.977375,30.5465649 C28.977375,31.3820649 28.300125,32.0623149 27.468,32.0623149 L8.532375,32.0623149 C7.699875,32.0623149 7.023,31.3820649 7.023,30.5465649 L7.023,18.2214399 L28.977375,18.2214399 Z"
  })))))))));
};
export default SvgGiftIcon;